import * as sprintfjs from './sprintfjs'

if (!Number.prototype.dechex) {
    Number.prototype.dechex = function() {
        let number = this
        if (number < 0) {
            number = 0xFFFFFFFF + number + 1
        }
        return parseInt (number, 10)
            .toString (16)
    }
}

if (!String.prototype.str_escape) {
    String.prototype.str_escape = function() {
        var escapes = ['~','=',',',':','-','&',"\\?",'%','#',"\\'",'\\"','\\+','/'];
        var str = this
        escapes.forEach((item, index) => {
            str = str.replace(new RegExp(item,'g'),'~'+sprintfjs.vsprintf('%02s',item.charCodeAt(0).dechex()).toUpperCase())
        });
        return str
    };
}
if (!String.prototype.str_unescape) {
    String.prototype.str_unescape = function() {
        var escapes = ['~','=',',',':','-','&','?','%','#',"'",'"','+','/','\\'];
        var str = this
        escapes.forEach((item, index) => {
            let repl = new RegExp("~"+sprintfjs.vsprintf('%02s',item.charCodeAt(0).dechex()).toUpperCase(),"g")
            str = str.replace(repl,item)
        });
        return str
    };
}


if (!Array.prototype.arrdecode) {
    Array.prototype.arrdecode = function() {
        this.forEach((item, index, array) => {
                 if(item.length === 0){
                     this.splice(index,1)
                 }else if('undefined' === item.length){
                     this.splice(index,1)
                 }else{
                     this[index] = this[index].str_unescape()
                 }
        });
        if(1 === this.length){
            return this[0]
        }else{
            return this
        }
    };
}
if (!Array.prototype.arrencode) {
    Array.prototype.arrencode = function() {
        this.forEach((item, index, array) => {
            if(item.length === 0){
                this.splice(index,1)
            }else
            if('undefined' === item.length){
                this.splice(index,1)
            }else {
                this[index] = this[index].str_escape()
            }
        });
        if(1 === this.length){
            return this[0]
        }else{
            return this
        }
    };
}






//////////////////
// WEBPACK FOOTER
// ./src/lib/index.js
// module id = null
// module chunks = 